const zeros = '00000000';

export const formatContractNumber = (contractNumber) => {
  const extractExtend = contractNumber?.replace(/-E\d{1,2}/g, '');
  const contractNumberLength = extractExtend.length;
  return 'Z' + zeros.slice(contractNumberLength) + contractNumber;
};
